import React from "react";
import Banner from "../../../../components/Banner";
import AccountSettings from "../../../../components/AccountSettings";
import Header from "../../../../components/Header";
import Bottombar from "../../../../components/Bottombar";
import Topbar from "../../../../components/Topbar";
import { PAYMENTS } from "../../../../constants/settingsStrings.js";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
import { Link } from "react-router-dom";
function EnteringPin() {
  return (
    <div className="overflow-hidden  dark:bg-white dark:text-black dark:h-screen">
      <Topbar />
      <div className="md:block hidden">
        <Header />
      </div>
      <div className="sm:hidden flex space-x-[100px]  mt-7 ">
        <Link to="/settings/paymentContinue ">
          <ArrowLeftIcon color="#545454" className="ml-4 w-[17px] h-[17px]" />
        </Link>

        <h3 className="dark:text-black font-bold">Payment Method</h3>
      </div>
      <div className="mt-5 sm:hidden">
        <div class="flex justify-between ">
          <div class="w-1/3 text-center">
            <div class="bg-[#42BA96] rounded-full h-[12px] w-[12px] inline-flex items-center justify-center">
              <span class="text-sm font-bold text-white">✓</span>
            </div>
            <div class="mt-2 text-[16px] font-sans font-bold dark:text-black">
              Details
            </div>
          </div>
          <div class="w-1/3 text-center">
            <div class="bg-[#42BA96] rounded-full h-[12px] w-[12px] inline-flex items-center justify-center pt-1">
              <span class="text-sm font-bold text-white">✓</span>
            </div>
            <div class="mt-2 text-[16px] font-sans font-bold dark:text-black">
              Payment
            </div>
          </div>
          <div class="w-1/3 text-center">
            <div class="bg-[#42BA96] rounded-full h-[12px] w-[12px] inline-flex items-center justify-center pt-2">
              <span class="text-sm font-bold text-white">{}</span>
            </div>
            <div class="mt-2 text-[16px] font-sans font-bold dark:text-black">
              Confirm
            </div>
            {/* <div className="absolute border-2 w-[119px] border-[#6200EE] top-[123px] left-[70px] mn-2"></div>
            <div className="absolute border-2 w-[117px] border-[#EEEEEE] top-[123px] left-[202px] mn-2"></div> */}
          </div>
        </div>
      </div>
      <div className="flex">
        <div className="hidden md:block">
          <AccountSettings active={PAYMENTS} />
        </div>
        <div className="w-[925px]  sm:w-[64vw] mt-2 h-[500px] rounded-[25px] sm:shadow-xl  sm:mx-10 my-4">
          <div className="hidden  md:block">
            <Banner />
          </div>

          <div className="hidden md:block mt-3">
            <div className="grid place-content-center ">
              <div className=" flex ">
                <div class=" flex space-x-10 ">
                  <div class="w-1/3 text-center mr-3">
                    <div class="bg-[#42BA96] rounded-full h-[25px] w-[25px] inline-flex items-center justify-center">
                      <span class="text-sm font-bold text-white w-[3px] h-[3px] mb-4 mr-3">
                        ✓
                      </span>
                    </div>
                    <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
                      Details
                    </div>{" "}
                  </div>
                  <div class="w-1/3 text-center">
                    <div class="bg-[#42BA96] rounded-full h-[25px] w-[25px] inline-flex items-center justify-center">
                      <span class="text-sm font-bold text-white w-[3px] h-[3px] mb-4 mr-3">
                        ✓
                      </span>
                    </div>
                    <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
                      Payment
                    </div>
                  </div>
                  <div class="w-1/3 text-center ml-3 ">
                    <div class="bg-[#42BA96] rounded-full h-[25px] w-[25px] inline-flex items-center justify-center pt-6">
                      <span class="text-sm font-bold text-white w-[3px] h-[3px] mb-4 mr-3 "></span>
                    </div>
                    <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
                      Confirm
                    </div>
                    {/* <div className="absolute border-2 w-[77px] border-[#6200EE] top-[353px] left-[735px] mn-2"></div>

                    <div className="absolute border-2 w-[69px] border-[#EEEEEE] top-[353px] left-[837px] mn-2"></div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="border rounded-[25px] sm:mt-10 mt-[100px] bg-[#D9D9D9] sm:ml-[300px]  ml-5 w-[350px] sm:h-[153px] h-[200px] mb-10 grid place-content-center ">
            <input
             
              placeholder="Enter your PIN to authorize the transaction. "
              className=" mx-2 text-black overflow-auto placeholder:text-black w-[300px] break-words focus:outline-none placeholder:text-[16px]  h-[46.91px] outline-none bg-[#D9D9D9]"
            />

            <div className="border-[1px] border-[#BDBDBD] w-[328px]"></div>
          </div>
        </div>
      </div>

      <h3 className="dark:text-black absolute text-[12px] text-[#878787] font-[900] mt-9  md:block hidden sm:left-[50%]  bottom-[70px] left-[40%]">
          Terms and conditions{" "}
      </h3>
      <Bottombar activeBar={'settings'} />
    </div>
  );
}

export default EnteringPin;
